import React, { useState } from "react";
import { GoogleMap, LoadScript, DirectionsRenderer } from "@react-google-maps/api";

const MapWithRoute = ({ directions, data, style, height = '400px' }) => {
  return (
    <div style={style}>
      <div className="flex flex-row">
      <div className="text-4xl font-bold" style={{
        textAlign: 'left',
        marginTop: 0,
        fontSize: '1.25rem',
        color: '#0f4e33',
        marginRight: '3rem'
      }}>
          Distance: <span style={{ color: '#0f4e33' }}>{data.totalDistance}</span>
        </div>
        <div className="text-4xl font-bold" style={{
          textAlign: 'left',
          margin: '1rem',
          marginTop: 0,
          fontSize: '1.25rem',
          color: '#0f4e33'
        }}>
          Time: <span style={{ color: '#0f4e33'}}>{data.totalDuration}</span>
      </div>
      </div>
      <GoogleMap
        mapContainerStyle={{ height: height, width: "100%" }}
        center={{ lat: 33.5565, lng: 72.8341 }} // Default center
        zoom={10}
      >
        {directions && <DirectionsRenderer directions={directions} />}
      </GoogleMap>
    </div>
  );
};

export default MapWithRoute;
